// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OGCWebServiceLayerRead
 */
export interface OGCWebServiceLayerRead {
  /**
   *
   */
  id: string;
  /**
   *
   */
  title?: string | null;
}

/**
 * Check if a given object implements the OGCWebServiceLayerRead interface.
 */
export function instanceOfOGCWebServiceLayerRead(value: object): value is OGCWebServiceLayerRead {
  if (!("id" in value) || value["id"] === undefined) return false;
  return true;
}

export function OGCWebServiceLayerReadFromJSON(json: any): OGCWebServiceLayerRead {
  return OGCWebServiceLayerReadFromJSONTyped(json, false);
}

export function OGCWebServiceLayerReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OGCWebServiceLayerRead {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    title: json["title"] === undefined ? undefined : json["title"] === null ? null : json["title"],
  };
}

export function OGCWebServiceLayerReadToJSON(json: any): OGCWebServiceLayerRead {
  return OGCWebServiceLayerReadToJSONTyped(json, false);
}

export function OGCWebServiceLayerReadToJSONTyped(
  value?: OGCWebServiceLayerRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    title: value["title"],
  };
}
